import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useLocation } from 'react-router';

const DEFAULT_HIGHLIGHT_ROW_TIMEOUT_SECONDS = 10;
const DEFAULT_LOCATION_CUSTOM_STATE_NAME = 'highlightId';
const DEFAULT_AUTO_SCROLL_ELEMENT_ID_PREFIX = 'highlight-';

const useLocationHighlightId = ({
  customStateName = DEFAULT_LOCATION_CUSTOM_STATE_NAME,
  elementIdPrefix = DEFAULT_AUTO_SCROLL_ELEMENT_ID_PREFIX,
  timeout = DEFAULT_HIGHLIGHT_ROW_TIMEOUT_SECONDS
} = {}) => {
  const location = useLocation();
  const [highlightId, setHighlightId] = useState(null);

  const scrollToHighlightRow = () => {
    setTimeout(() => {
      const highlightedElement = document.getElementById(
        `${elementIdPrefix}${highlightId}` //default id selector: highlight-id (for example: highlight-38)
      );
      if (highlightedElement) {
        highlightedElement.scrollIntoView({ block: 'center' });
      }
    }, 0);
  };

  const removeHighlightIdAfterTimeout = () => {
    setTimeout(() => {
      setHighlightId(null);
    }, timeout * 1000);
  };

  useEffect(() => {
    const locationHighlightId = _.get(
      location,
      `state.${customStateName}`,
      null
    );

    setHighlightId(locationHighlightId);
  }, [location]);

  useEffect(() => {
    if (!highlightId) return;

    scrollToHighlightRow();
    if (timeout > 0) {
      removeHighlightIdAfterTimeout();
    }
  }, [highlightId]);

  return highlightId;
};

export default useLocationHighlightId;
